const env = process.env.NODE_ENV

var url = 'https://equity.aojuai.com/equitybackfee';
// var url = 'http://192.168.11.103:19091/equitybackfee'; 
//--------------------------------------------------
  //移动权益金接口
var url2 = 'https://equity.aojuai.com/pointsequity';
// var url2 = 'http://192.168.11.103:19091/pointsequity';   
// var url = 'https://train.aojuai.com';
// 新服务
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url, //线上 
    baseURL2 :url2,
  },
  production:{
     baseURL :'https://equity.aojuai.com/equitybackfee',
      baseURL2 :'https://equity.aojuai.com/pointsequity',

  }
}
export default {  
  baseURL:config[env].baseURL,
  baseURL2:config[env].baseURL2,
}